/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronLeft from '@telus-uds/palette-koodo/build/rn/icons/ChevronLeft'
import PaletteIconChevronRight from '@telus-uds/palette-koodo/build/rn/icons/ChevronRight'
const theme = {
  appearances: {
    compact: {
      description: 'Determines if the "Next" and "Previous" labels should be omitted',
      type: 'state',
      values: [ true ]
    },
    direction: {
      description: "Determines which way does the button navigate in Pagination's context",
      type: 'state',
      values: [ 'previous', 'next' ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    { if: { compact: true }, tokens: { displayLabel: false } },
    {
      if: { viewport: [ 'xs', 'sm' ] },
      tokens: {
        borderRadius: 32,
        displayLabel: false,
        paddingBottom: 8,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 8
      }
    },
    {
      if: { hover: true },
      tokens: {
        borderBottomWidth: 1,
        borderColor: '#000000',
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderTopWidth: 1,
        iconDisplace: 4,
        textLine: 'none'
      }
    },
    {
      if: { focus: true },
      tokens: {
        borderBottomWidth: 1,
        borderColor: '#000000',
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderTopWidth: 1
      }
    },
    {
      if: { pressed: true },
      tokens: { backgroundColor: '#000000', color: '#666666' }
    },
    {
      if: { direction: 'previous' },
      tokens: { icon: PaletteIconChevronLeft }
    },
    {
      if: { direction: 'next' },
      tokens: { icon: PaletteIconChevronRight }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderBottomWidth: 0,
    borderColor: 'rgba(0, 0, 0, 0)',
    borderLeftWidth: 0,
    borderRadius: 4,
    borderRightWidth: 0,
    borderTopWidth: 0,
    color: '#000000',
    displayLabel: true,
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '600',
    height: null,
    icon: null,
    iconDisplace: 0,
    iconSize: 16,
    lineHeight: 1.5,
    outerBorderColor: 'transparent',
    outerBorderWidth: 1,
    paddingBottom: 12,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 12,
    textAlign: 'center',
    textLine: 'none',
    width: null
  }
}
export default theme
